// Note: Subject and Section services removed as they're school management related
import { convertToLabelValue } from "../../utils/common";
import { _setClasses, _setRoles, _setUsers, _setDepartment, _setDesignation, _setLeaveTypes, _setClassLoading, _setImportClasses, _setImportSubjects } from "../slices/baseSetup.slice"; // Make sure to import from the correct file
import { getDepartmentList } from "../../services/workspace/department.service";
import { getDesignationList } from "../../services/workspace/designation.service";
import { getRoleList } from "../../services/workspace/role.service";
import { getUserList } from "../../services/workspace/user.service";
import { getStaffList } from "../../services/workspace/staff.service";
import { getLeaveTypeList } from "../../services/workspace/leaveType.service";
import { getImportData } from "../../services/workspace/global.service";

export const _fetchDepartments = (refresh = false) => async (dispatch) => {
    try {
        const result = await getDepartmentList();
        
        const response = result?.department?.data;
 

        if (response) {
            const formatedData = convertToLabelValue(response)
           
            dispatch(_setDepartment([...formatedData]));
        } else {
            dispatch(_setDepartment([]));
        }
    } catch (error) {
        console.error("An error occurred while fetching department data:", error);
    }
};

export const _fetchImportData = () => async (dispatch) => {
    try {
        const result = await getImportData(); 
        const response = result;
        if (response) {
            const classes = response.classes
            const subjects = response.subjects;
            // const formatedClasses = convertToLabelValue(classes)
            // const formatedSubjects = convertToLabelValue(subjects)
            dispatch(_setImportClasses(classes));
            dispatch(_setImportSubjects(subjects));
        } else {
            dispatch(_setImportClasses([]));
            dispatch(_setImportSubjects([]));
        }
    } catch (error) {
        console.error("An error occurred while fetching department data:", error);
    }
};

export const _fetchRoles = (refresh = false) => async (dispatch) => {
    try {
        const result = await getRoleList();
        const response = result?.data;
        if (response) {
            const formatedData = convertToLabelValue(response)
            dispatch(_setRoles([...formatedData]));
        } else {
            dispatch(_setRoles([]));
        }
    } catch (error) {
        console.error("An error occurred while fetching roles data:", error);
    }
};

export const _fetchDesignations = (refresh = false) => async (dispatch) => {
    try {
        const result = await getDesignationList({  with: "department,roles"});
        const response = result?.designation?.data;
        if (response) {
            const formatedData = convertToLabelValue(response)
            dispatch(_setDesignation(formatedData));
        } else {
            dispatch(_setDesignation([]));
        }
    } catch (error) {
        console.error("An error occurred while fetching designation data:", error);
    }
};

// Note: _fetchSections and _fetchSubjects removed as they're school management related
// These functions are not needed for HR management system

// Note: _fetchClasses removed as class.service is not available for HR management system

// Thunk for fetching users
export const _fetchUsers = (filter) => async (dispatch) => {
    try {
        const response = await getUserList(filter);
        
        if (response.user) { 
        const formatedData = convertToLabelValue(response.user.data);
        dispatch(_setUsers(formatedData)); // Dispatch the subjects to the state
      } else {
        dispatch(_setUsers([]));
      }
    } catch (error) {
      console.error("An error occurred while fetching subjects:", error);
    }
  };

// Thunk for fetching users
export const _fetchStaff = (filter) => async (dispatch) => {
    try {
        const response = await getStaffList(filter);
        if (response) {
            const formatedData = convertToLabelValue(response.data, true)
            dispatch(_setUsers(formatedData)); // Dispatch the subjects to the state
        } else {
            dispatch(_setUsers([]))
        }
    } catch (error) {
        console.error("An error occurred while fetching subjects:", error);
    }
};

// Thunk for fetching classes
export const _fetchLeaveTypes = () => async (dispatch) => {
    try {
        const response = await getLeaveTypeList();
        if (response?.data) {
            const formatedData = convertToLabelValue(response.data)
            dispatch(_setLeaveTypes(formatedData)); // Dispatch the subjects to the state
        } else {
            dispatch(_setLeaveTypes([]))
        }
    } catch (error) {
        console.error("An error occurred while fetching leave Types:", error);
    }
};

// Note: _fetchSyallbus removed as syllabus.service is not available for HR management system

